export interface Announcement {
  text: string;
  date: string;
}

export function isAnnouncement (obj: unknown): obj is Announcement {
  const announcement = obj as Announcement
  return !!announcement.text && !!announcement.date
}
